import classNames from "classnames";

import { useCallback, useEffect, useRef } from "react";

type DialogProps = {
	open: boolean;
	children: React.ReactNode;
	onClose?: () => void;
	className?: string;
};

const Dialog = ({ open, children, onClose, className }: DialogProps) => {
	const dialogRef = useRef<HTMLDialogElement>(null);

	const openDialog = useCallback(() => {
		dialogRef.current?.showModal();
	}, []);

	const closeDialog = useCallback(() => {
		dialogRef.current?.close();
		onClose?.();
	}, [onClose]);

	useEffect(() => {
		if (open) {
			openDialog();
		} else {
			closeDialog();
		}
	}, [open, closeDialog, openDialog]);

	return (
		<dialog
			onClose={onClose}
			onClick={onClose}
			ref={dialogRef}
			className={classNames(
				`bg-elevated-2 rounded-2xl max-h-1/2 absolute inset-0 z-50 backdrop:bg-black/50`,
				className,
			)}
		>
			<div
				onClick={(e) => e.stopPropagation()} // Prevent click events on children from propagating
			>
				{children}
			</div>
		</dialog>
	);
};

export default Dialog;
